import { ProductEntity, ProductCategoryEntity } from 'src/modules/products';
import { LocationTypeEntity } from 'src/modules/locationTypes';
import { Locale } from 'src/modules/locale';

export interface ProfessionalsDownloadsProductFiltersType {
  term: string;
  locale?: Locale;
  productCategories?: { id: string }[];
  locationTypes?: { id: string }[];
}

export interface ProfessionalsDownloadsProductPaginationType {
  offset?: number;
  limit?: number;
}

export interface ProfessionalsDownloadsProductSortOrderType {
  name: string;
  direction: 'asc' | 'desc';
}

export enum ProfessionalsDownloadsProductsActions {
  FetchDataBegin = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/FETCH_DATA/BEGIN',
  FetchDataSuccess = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/FETCH_DATA/SUCCESS',
  FetchDataError = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/FETCH_DATA/ERROR',
  FetchDetailsBegin = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/FETCH_DETAILS/BEGIN',
  FetchDetailsSuccess = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/FETCH_DETAILS/SUCCESS',
  FetchDetailsError = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/FETCH_DETAILS/ERROR',
  SearchBegin = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/SEARCH/BEGIN',
  SearchSuccess = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/SEARCH/SUCCESS',
  SearchError = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/SEARCH/ERROR',
  SearchSuggestionsBegin = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/SEARCH_SUGGESTIONS/BEGIN',
  SearchSuggestionsSuccess = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/SEARCH_SUGGESTIONS/SUCCESS',
  SearchSuggestionsError = 'PROFESSIONALS/DOWNLOADS/PRODUCTS/SEARCH_SUGGESTIONS/ERROR',
}

export interface ProfessionalsDownloadsProductsStore {
  isDataLoading: boolean;
  isDataLoaded: boolean;
  isDetailsLoading: boolean;
  isDetailsLoaded: boolean;
  error: any;
  isResultsLoading: boolean;
  isResultsLoaded: boolean;
  result: ProductEntity;
  results: ProductEntity[];
  allResults: ProductEntity[];
  searchResultsCount: number;
  isSearchSuggestionsResultsLoading: boolean;
  searchSuggestionsResults: ProductEntity[];
  productCategories: ProductCategoryEntity[];
  locationTypes: LocationTypeEntity[];
  filters: ProfessionalsDownloadsProductFiltersType;
  pagination: ProfessionalsDownloadsProductPaginationType;
  sortOrder: ProfessionalsDownloadsProductSortOrderType;
}
